var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWatermarkedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_11560_30604)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
    fill: "#FFE6F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 0.193359C18.5205 0.193359 23.8066 5.47948 23.8066 12C23.8066 18.5205 18.5205 23.8066 12 23.8066C5.47948 23.8066 0.193359 18.5205 0.193359 12C0.193359 5.47948 5.47948 0.193359 12 0.193359Z",
    stroke: "#FFCBE4",
    strokeWidth: 0.387097
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11560_30604)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.61278 16.8376H15.387M12.9676 12.4827V10.3053C12.9676 9.57951 13.4515 9.57951 13.4515 8.61177C13.4515 8.22678 13.2985 7.85755 13.0263 7.58532C12.7541 7.31309 12.3849 7.16016 11.9999 7.16016C11.1966 7.16016 10.5483 7.64403 10.5483 8.61177C10.5483 9.57951 11.0321 9.57951 11.0321 10.3053V12.4827M15.5176 12.836C15.4051 12.7237 15.2715 12.6347 15.1245 12.5741C14.9776 12.5135 14.8201 12.4825 14.6612 12.4827H9.33858C9.01776 12.4827 8.71007 12.6102 8.48321 12.837C8.25635 13.0639 8.12891 13.3716 8.12891 13.6924V14.4182C8.12891 14.5466 8.17989 14.6696 8.27063 14.7604C8.36137 14.8511 8.48445 14.9021 8.61278 14.9021H15.387C15.5153 14.9021 15.6384 14.8511 15.7291 14.7604C15.8199 14.6696 15.8708 14.5466 15.8708 14.4182V13.6924C15.8708 13.3731 15.745 13.0634 15.5176 12.836Z",
    stroke: "#C1005D",
    strokeWidth: 0.93,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_11560_30604",
    x: 0,
    y: 0,
    width: 24,
    height: 24,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.41935
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.999911 0 0 0 0 0.633878 0 0 0 0 0.809574 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_11560_30604"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11560_30604"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11.6129,
    height: 11.6129,
    fill: "white",
    transform: "translate(6.19336 6.19336)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWatermarkedIcon);
export default __webpack_public_path__ + "static/media/watermarked_icon.c14d82385002a5dbeca2a8e5a7709b94.svg";
export { ForwardRef as ReactComponent };